import React, {useEffect, useRef, useState} from 'react';

const CentralizedView = (props) => {
    const {title, children} = props;
    const contentRef = useRef(null);
    const [shouldCentralize, setShouldCentralize] = useState(true);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (contentRef.current) {
                const childWidth = contentRef.current.scrollWidth;
                const screenWidth = window.innerWidth;
                setShouldCentralize(childWidth < screenWidth);
            }
        });

        if (contentRef.current) observer.observe(contentRef.current);
        return () => observer.disconnect();
    }, []);

    return (


    <div className={"centralized-div1"}>
           <div className={shouldCentralize ? "centralized-div-content": "left-div-content"}>
               <div ref={contentRef}>
                {children}
               </div>
            </div>
        </div>
    );
};

export default CentralizedView;
